import { isActiveConversationUserOrGroup, isGroupChat, isSingleChat } from "../../../Helpers/Chat/ChatHelper";
import {
  CHAT_TYPE_GROUP,
  GROUP_CHAT_PROFILE_UPDATED_NOTIFY,
    GROUP_UPDATE_ACTIONS,
    MSG_RECEIVE_STATUS,
    MSG_RECEIVE_STATUS_CARBON,
    MSG_SENT_SEEN_STATUS_CARBON,
  } from "../../../Helpers/Chat/Constant";
import { changeTimeFormat } from "../../../Helpers/Chat/RecentChat";
import { formatUserIdToJid, isLocalUser } from "../../../Helpers/Chat/User";
import { getFromLocalStorageAndDecrypt } from "../../../Helpers/Chat/webChatEncryptDecrypt";
import { TYPE_DELAY_TIME } from "../../../Helpers/Constants";
import { getMessageObjReceiver } from "../../../Helpers/Utility";
import { addChatConversationHistory } from "../../../Redux/feature/chatConversationHistorySlice";
import { addchatSeenPendingMsg, removechatSeenPendingMsg } from "../../../Redux/feature/chatSeenPendingMsgSlice";
import { updateRecentChat } from "../../../Redux/feature/recentChatDataSlice";
import { addTypingStatus,removeTypingStatus } from "../../../Redux/feature/typingStatusSlice";
import { unreadCountDelete, updateContactUnreadCount, updateUnreadCount } from "../../../Redux/feature/unreadCountSlice";
import { store } from "../../../Redux/store";
import SDK from "../../../SDK";

const getMessageSenderDetails = (newChatFrom, rosterDataArray) => {
  const rosterDetail = rosterDataArray.find((profile) => {
    const rosterJid = profile.username ? profile.username : profile.jid;
    return newChatFrom === rosterJid;
  });
  return rosterDetail || { contactNumber: newChatFrom };
};

/**
 * Update all delivered message seen status
 */
export const updateMsgSeenStatus = () => {
  const state = store.getState();
  const [ data ] = state?.activeChatData.data
  if (data?.recent) {
    const pendingMessages = state?.chatSeenPendingMsgData?.data || [];
    pendingMessages.map((message) => {
      const fromUserId = isGroupChat(message.chatType) ? message.publisherId : message.fromUserId;
      const groupId = isGroupChat(message.chatType) ? message.fromUserId : "";
      if (isActiveConversationUserOrGroup(message.fromUserId)) {
        if (GROUP_UPDATE_ACTIONS.indexOf(message?.profileUpdatedStatus) > -1) {
          if (!isLocalUser(message.publisherId)) SDK.updateRecentChatUnreadCount(message?.fromUserJid);
        } else {
          SDK.sendSeenStatus(formatUserIdToJid(fromUserId), message.msgId, groupId);
          store.dispatch(removechatSeenPendingMsg());
        }
      }
    });
  }
};

/**
 const { activeChatData:{data:activeChatData } } = store.getState()
        let activeData = activeChatData[0]
        let groupId=isSingleChat(messgeObject.chatType) ? "" : messgeObject.fromUserId
        let composerId = isSingleChat(messgeObject.chatType) ? messgeObject.fromUserId : messgeObject.publisherId
        if(currentState.browserTab.data || !isActiveConversationUserOrGroup(messgeObject.fromUserId, messgeObject.chatType)){          
          await SDK.sendSeenStatus(formatUserIdToJid(composerId), messgeObject.msgId, groupId)
          store.dispatch(removechatSeenPendingMsg());        
        }else{
            store.dispatch(addchatSeenPendingMsg(messgeObject));
        }
 */

const sentSeenStatus=async(messgeObject, currentState) => {        
  const newChatTo = messgeObject.msgType === "carbonSentMessage" ? messgeObject.toUserId : messgeObject.fromUserId;
  const singleChat = isSingleChat(messgeObject.chatType);
  if (isActiveConversationUserOrGroup(newChatTo)) {
    const publisherId = singleChat ? newChatTo : messgeObject.publisherId;
    if ([MSG_RECEIVE_STATUS, MSG_RECEIVE_STATUS_CARBON].indexOf(messgeObject.msgType) > -1) {
      if (currentState?.browserTab?.data) {
        const groupId = singleChat ? "" : newChatTo;
        SDK.sendSeenStatus(formatUserIdToJid(publisherId), messgeObject.msgId, groupId);
        store.dispatch(removechatSeenPendingMsg());
      } else {
        store.dispatch(addchatSeenPendingMsg(messgeObject));
      }
    }
    if (GROUP_UPDATE_ACTIONS.indexOf(messgeObject?.profileUpdatedStatus) && !isLocalUser(messgeObject.publisherId)) {
      SDK.updateRecentChatUnreadCount(messgeObject?.fromUserJid);
    }
  } else {
    // If the Chat is Already Opened but if it is Not Currently Active, Store the Messages for Sending Seen Status
    if (!isLocalUser(messgeObject.publisherId)) {
      store.dispatch(addchatSeenPendingMsg(messgeObject));
    }
  }
}
 
export const updateMessageUnreadCount = (messgeObject, stateObject) => {
  const { msgType, fromUserId, publisherId, groupId, toUserId} = messgeObject;
  if ([MSG_RECEIVE_STATUS, MSG_RECEIVE_STATUS_CARBON,GROUP_CHAT_PROFILE_UPDATED_NOTIFY].indexOf(msgType) > -1 && !isLocalUser(publisherId)) {
    store.dispatch(updateUnreadCount({ fromUserId }))
    sentSeenStatus(messgeObject,stateObject)
  }
  if ([MSG_SENT_SEEN_STATUS_CARBON].indexOf(msgType) > -1) {
    const updateId = groupId ? groupId : toUserId;
    store.dispatch(unreadCountDelete({ fromUserId: updateId }));
  }
  
};


export const updateRecentChatMessage = (messgeObject, stateObject) => {
  const { recentChatData, rosterData } = stateObject;
  const { data: rosterDataArray = [] } = rosterData;
  const { rosterData: { recentChatNames } = {} } = recentChatData;
  if (!recentChatNames) {
    return;
  }
  const { msgType, fromUserId, fromUserJid, toUserId, msgId, timestamp, chatType, msgBody, publisherId } = messgeObject;

  const newChatTo = msgType === "carbonSentMessage" ? toUserId : fromUserId;
  const newChatFrom = chatType === "groupchat" ? publisherId : fromUserId;
  const updateTime = changeTimeFormat(timestamp);
  const userDetails = getMessageSenderDetails(newChatFrom, rosterDataArray);
  const leftGroup = !msgType && msgType === "receiveMessage" && msgBody === "3";
  const x = new Date();
  let UTCseconds = x.getTime() + x.getTimezoneOffset() * 60 * 1000;

  // Temp - Reorder Issue Fix
  if (Number(UTCseconds).toString().length > 13) UTCseconds = UTCseconds / 1000;

  /**
   * update the chat message if message alredy exist in recent chat
   */
  if (recentChatNames.indexOf(newChatTo) !== -1) {
    const constructNewMessage = {
      ...messgeObject,
      MessageType: msgType ? msgType : msgBody.message_type || "",
      msgType: msgBody.message_type ? msgBody.message_type : msgType,
      publisher: newChatFrom,
      publisherId: newChatFrom,
      leftGroup: leftGroup,
      filterBy: newChatTo,
      fromUserId: newChatTo,
      chatType: chatType,
      contactDetails: userDetails,
      createdAt: updateTime,
      timestamp: parseInt(UTCseconds)
    };
    store.dispatch(updateRecentChat(constructNewMessage));
  } else {
    /**
     * New chat that is not alreay exist in recent chat
     */
    const getMute = getFromLocalStorageAndDecrypt("tempMuteUser");
    let parserLocalStorage = getMute ? JSON.parse(getMute) : {};
    const isMuted = parserLocalStorage[newChatTo] ? 1 : 0;
    if (isMuted) {
      SDK.updateMuteNotification(formatUserIdToJid(newChatTo, chatType), true);
    }
    const newMessage = {
      archiveStatus: 0,
      chatType: chatType,
      msgBody: msgBody,
      msgId: msgId,
      msgStatus: 0,
      muteStatus: isMuted,
      msgType: msgBody.message_type ? msgBody.message_type : msgType,
      deleteStatus: 0,
      unreadCount: 0,
      fromUserId: newChatTo,
      timestamp: parseInt(UTCseconds),
      publisher: newChatFrom,
      publisherId: newChatFrom,
      toUserId: toUserId,
      createdAt: updateTime,
      filterBy: newChatTo
    };
    store.dispatch(updateRecentChat(newMessage));
    const unreadCountArray = {
      fromUserId : newChatTo,
      unreadCount:1
    }
    store.dispatch(updateContactUnreadCount(unreadCountArray))

  }
  if (!msgType && msgType === "receiveMessage" && (msgBody === "4" || msgBody === "2")) {
    SDK.getGroupProfileUpdate(fromUserJid);
  }
};
  
export const updateConversationMessage = (messgeObject, currentState) => {
  const newChatTo = messgeObject.msgType === "carbonSentMessage" ? messgeObject.toUserId : messgeObject.fromUserId;
  const conversationChatObj = getMessageObjReceiver(messgeObject, messgeObject.fromUserId);
  const dispatchData = {
    data: [conversationChatObj],
    ...({ userJid: formatUserIdToJid(newChatTo) })
  };
  store.dispatch(addChatConversationHistory(dispatchData));
};

let typingTime= {}
export const typingStatus=(res)=>{
  const { msgType="" }=res
  if(msgType === "composing" || msgType === "carbonComposing"){
    let resData={}
    if(res.groupId){
      let displayName= getGrpParticipantsDisplayName(formatUserIdToJid(res.groupId,CHAT_TYPE_GROUP),res.fromUserId) 
      resData={ ...res,displayName: displayName }
    }else{
      resData={ ...res,displayName:null }
    }
    store.dispatch(addTypingStatus(resData))
    clearTimeout(typingTime[resData.fromUserId]);
    typingTime[resData.fromUserId] = setTimeout(() => {
      store.dispatch(removeTypingStatus(resData));
    }, TYPE_DELAY_TIME + 1000);
  }else{
    let resData={}
    if(res.groupId){
      let displayName= getGrpParticipantsDisplayName(formatUserIdToJid(res.groupId,CHAT_TYPE_GROUP),res.fromUserId) 
      resData={ ...res,displayName: displayName }
    }else{
      resData={ ...res,displayName:null }
    }
    store.dispatch(removeTypingStatus(resData))
  }
}
  
const getGrpParticipantsDisplayName=(grpJid,composerId)=>{
  const {groupsMemberParticipantsListData:{ groupParticipants = { } }={}} = store.getState()
  return groupParticipants[grpJid].find(ele=>( ele.userId === composerId)).userProfile.nickName
}